
<div
  v-tooltip="tooltipIfDisabled"
  :class="commonEntriesPropertiesCssClasses"
>
  <date-picker
    :mode="objectModelProperty.datetime_mode"
    :min="minDatetime"
    :max="maxDatetime"
    v-model.sync="localValue"
    :disabled="disabled"
  ></date-picker>
</div>
